import React from 'react'

import Slider from './Slider';
import S1 from './Section1';
import S2 from './Section2';
import S3 from './Section3';
import S4 from './Section4';

const Home = () => {
    return (
        <>
            <Slider/>
            <S1/>
            <S2/>
            <S3/>
            <S4/>
        </>            
    )
}

export default Home;
